// extracted by mini-css-extract-plugin
module.exports = {"emailSettingsItem":"styles_emailSettingsItem__umKHa","statusMessage":"styles_statusMessage__13gU2","statusIsError":"styles_statusIsError__1hN8Z"};